import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../core/auth/auth-context';



type SecureRouteProps = any & {
  noRedirect?: boolean;
};

export function SecureRoute({ children, noRedirect }: SecureRouteProps) {
  const { authenticated } = useAuthContext();

  if (!authenticated && !noRedirect) {
    return <Navigate to="/" />;
  }

  return children;
}
